export default __webpack_public_path__ + "static/media/yellowbrickhouse.be2fef0a.jpg";